import {
  GET_VENDORS,
  GET_VENDORS_FAILED,
  GET_VENDORS_SUCCEEDED,
  GET_RECENT_VENDORS,
  GET_RECENT_VENDORS_FAILED,
  GET_RECENT_VENDORS_SUCCEEDED,
  FETCH_VENDOR_ALIASES,
  FETCH_VENDOR_ALIASES_FAILED,
  FETCH_VENDOR_ALIASES_SUCCEEDED,
  ADD_VENDOR_ALIAS,
  ADD_VENDOR_ALIAS_FAILED,
  ADD_VENDOR_ALIAS_SUCCEEDED,
  CHANGE_VENDOR_ALIAS,
  CHANGE_VENDOR_ALIAS_FAILED,
  CHANGE_VENDOR_ALIAS_SUCCEEDED,
  DELETE_VENDOR_ALIAS,
  DELETE_VENDOR_ALIAS_FAILED,
  DELETE_VENDOR_ALIAS_SUCCEEDED,
  TOGGLE_VENDOR_FILTER_DRAWER,
  ADD_VENDOR_TAG,
  ADD_VENDOR_TAG_FAILED,
  ADD_VENDOR_TAG_SUCCEEDED,
  CHANGE_VENDOR_TAG,
  CHANGE_VENDOR_TAG_FAILED,
  CHANGE_VENDOR_TAG_SUCCEEDED,
  DELETE_VENDOR_TAG,
  DELETE_VENDOR_TAG_FAILED,
  DELETE_VENDOR_TAG_SUCCEEDED,
} from 'Redux/Types/VendorTypes'

const INITIAL_STATE = {
  aliases: [],

  records: [],
  nextPage: null,
  previousPage: null,
  fetchingVendors: false,

  recentVendors: [],
  fetchingRecentVendors: false,

  filterDrawer: {
    open: false,
  },

  addingAlias: false,
  changingAlias: false,
  deletingAlias: false,
  deleted: false,

  addingTag: false,
  changingTag: false,
  deletingTag: false,
}

const getVendorAttrs = (vendors, alias) => {
  const targetVendor = vendors.find(({ alias: a }) => a && alias && a === alias)
  if (targetVendor) {
    return {
      expenseCategory: targetVendor.expenseCategory,
      glCode: targetVendor.glCode,
    }
  }
  return {
    expenseCategory: '',
    glCode: '',
  }
}

const updateVendor = ({
  alias,
  id,
  params,
  records,
  retainPreviousParams = false,
  swapWithPreviousParams = false,
}) => {
  const previousParams = (vendor, params) =>
    Object.keys(params).reduce((acc, param) => {
      acc[`previous${param}`] = vendor[param]
      return acc
    }, {})

  const swappedParams = (vendor, params) =>
    Object.keys(params).reduce((acc, param) => {
      acc[param] = vendor[`previous${param}`]
      return acc
    }, {})

  return records.map((vendor) => {
    if (alias) {
      if (vendor.alias === alias) {
        return {
          ...vendor,
          ...params,
          ...(retainPreviousParams ? previousParams(vendor, params) : {}),
          ...(swapWithPreviousParams ? swappedParams(vendor, params) : {}),
        }
      }
    } else if (id) {
      if (vendor.id === id) {
        return {
          ...vendor,
          ...params,
          ...(retainPreviousParams ? previousParams(vendor, params) : {}),
          ...(swapWithPreviousParams ? swappedParams(vendor, params) : {}),
        }
      }
    }
    return vendor
  })
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_VENDORS:
      return {
        ...state,
        fetchingVendors: true,
      }
    case GET_VENDORS_FAILED:
      return {
        ...state,
        fetchingVendors: false,
      }
    case GET_VENDORS_SUCCEEDED:
      return {
        ...state,
        fetchingVendors: false,
        records: payload.data,
        nextPage: payload.next,
        previousPage: payload.previous,
      }

    case FETCH_VENDOR_ALIASES:
      return {
        ...state,
        fetchingAliases: true,
      }
    case FETCH_VENDOR_ALIASES_FAILED:
      return {
        ...state,
        fetchingAliases: false,
      }
    case FETCH_VENDOR_ALIASES_SUCCEEDED:
      return {
        ...state,
        aliases: payload.data,
        fetchingAliases: false,
      }

    case GET_RECENT_VENDORS:
      return {
        ...state,
        fetchingRecentVendors: true,
      }
    case GET_RECENT_VENDORS_FAILED:
      return {
        ...state,
        fetchingRecentVendors: false,
      }
    case GET_RECENT_VENDORS_SUCCEEDED:
      return {
        ...state,
        fetchingRecentVendors: false,
        recentVendors: payload.data,
      }

    case ADD_VENDOR_ALIAS: {
      const {
        ids: [id],
        alias,
      } = payload

      return {
        ...state,
        addingAlias: true,
        records: updateVendor({
          id,
          params: {
            alias,
            expenseCategory: '',
            glCode: '',
          },
          records: state.records,
          retainPreviousParams: true,
        }),
      }
    }
    case ADD_VENDOR_ALIAS_FAILED:
      return {
        ...state,
        addingAlias: false,
        records: updateVendor({
          id: payload.id,
          params: { alias: '', expenseCategory: '', glCode: '' },
          records: state.records,
          swapWithPreviousParams: true,
        }),
      }
    case ADD_VENDOR_ALIAS_SUCCEEDED: {
      return {
        ...state,
        addingAlias: false,
        records: updateVendor({
          id: payload.id,
          params: {
            alias: payload.alias,
            glCode: payload.glCode,
            expenseCategory: payload.expenseCategory,
          },
          records: state.records,
        }),
        aliases: [...state.aliases, { value: { name: payload.alias } }],
      }
    }

    case CHANGE_VENDOR_ALIAS: {
      const {
        ids: [id],
        alias,
      } = payload
      return {
        ...state,
        changingAlias: true,
        records: updateVendor({
          id,
          params: { alias, ...getVendorAttrs(state.records, alias) },
          records: state.records,
          retainPreviousParams: true,
        }),
      }
    }
    case CHANGE_VENDOR_ALIAS_FAILED:
      return {
        ...state,
        changingAlias: false,
        records: updateVendor({
          id: payload.id,
          params: { alias: '', expenseCategory: '', glCode: '' },
          records: state.records,
          swapWithPreviousParams: true,
        }),
      }
    case CHANGE_VENDOR_ALIAS_SUCCEEDED: {
      return {
        ...state,
        changingAlias: false,
        records: updateVendor({
          id: payload.id,
          params: {
            alias: payload.alias,
          },
          records: state.records,
        }),
      }
    }

    case DELETE_VENDOR_ALIAS:
      return {
        ...state,
        deleted: false,
        deletingAlias: true,
      }
    case DELETE_VENDOR_ALIAS_FAILED:
      return {
        ...state,
        deleted: false,
        deletingAlias: false,
      }
    case DELETE_VENDOR_ALIAS_SUCCEEDED: {
      return {
        ...state,
        deleted: true,
        deletingAlias: false,
        records: updateVendor({
          id: payload.id,
          params: {
            alias: null,
            expenseCategory: '',
            glCode: '',
          },
          records: state.records,
        }),
      }
    }

    case ADD_VENDOR_TAG: {
      const { id, alias, tagName, value } = payload
      return {
        ...state,
        addingTag: true,
        records: updateVendor({
          id,
          alias,
          params: { [tagName]: value },
          records: state.records,
          retainPreviousParams: true,
        }),
      }
    }
    case ADD_VENDOR_TAG_FAILED: {
      const { id, alias, tagName } = payload
      return {
        ...state,
        addingTag: false,
        records: updateVendor({ id, alias, params: { [tagName]: '' }, records: state.records }),
      }
    }
    case ADD_VENDOR_TAG_SUCCEEDED: {
      return {
        ...state,
        addingTag: false,
        records: updateVendor({
          alias: payload.alias,
          id: payload.id,
          params: {
            [payload.tagName]: payload.value,
          },
          records: state.records,
        }),
      }
    }

    case CHANGE_VENDOR_TAG: {
      const { id, alias, tagName, newValue } = payload
      return {
        ...state,
        changingTag: true,
        records: updateVendor({
          id,
          alias,
          params: { [tagName]: newValue },
          records: state.records,
          retainPreviousParams: true,
        }),
      }
    }
    case CHANGE_VENDOR_TAG_FAILED: {
      const { id, alias, tagName } = payload
      return {
        ...state,
        changingTag: false,
        records: updateVendor({
          id,
          alias,
          params: { [tagName]: '' },
          records: state.records,
          swapWithPreviousParams: true,
        }),
      }
    }
    case CHANGE_VENDOR_TAG_SUCCEEDED: {
      return {
        ...state,
        changingTag: false,
        records: updateVendor({
          alias: payload.alias,
          id: payload.id,
          params: {
            [payload.tagName]: payload.value,
          },
          records: state.records,
        }),
      }
    }

    case DELETE_VENDOR_TAG:
      return {
        ...state,
        deletingTag: true,
        deleted: false,
      }
    case DELETE_VENDOR_TAG_FAILED:
      return {
        ...state,
        deletingTag: false,
        deleted: false,
      }
    case DELETE_VENDOR_TAG_SUCCEEDED: {
      return {
        ...state,
        deletingTag: false,
        records: updateVendor({
          alias: payload.alias,
          id: payload.id,
          params: {
            [payload.tagName]: null,
          },
          records: state.records,
        }),
        deleted: true,
      }
    }

    case TOGGLE_VENDOR_FILTER_DRAWER: {
      return {
        ...state,
        filterDrawer: {
          ...state.filterDrawer,
          open: payload,
        },
      }
    }

    default:
      return state
  }
}
